export default __webpack_public_path__ + "static/enmascarar-714a7ee6ffea430fe6f3937a6bd43401.png";